import { Component, OnInit, Inject } from "@angular/core";
import { OnlineAnswerService } from "../../../services/onlineanswer.service";
import { CAnswerStatus } from "../../../models/onlineAnswer.models/answerStatus.model";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "directOnlineAnswering",
  templateUrl: "directOnlineAnswering.component.html",
})
export class DirectOnlineAnsweringComponent implements OnInit {
  ngOnInit(): void {
    this.acceptionCode = this.route.snapshot.queryParamMap.get("ac");
    this.phoneNumber = this.route.snapshot.queryParamMap.get("pn");

    if (this.acceptionCode && this.phoneNumber) {
      this.CheckAnswer();
    } else {
      this.showLoadingGif = false;
      this.showErrorMessage = true;
      this.errorMessage = "مقادیر وارد شده صحیح نمی باشد";
    }
  }

  acceptionCode: string = "";
  phoneNumber: string = "";

  answerStatus: CAnswerStatus = new CAnswerStatus();

  answerChecked: boolean = false;
  //0 - بیمار یافت نشد
  //1 - جواب آماده است
  //2 - جواب آماده نیست
  //3 - جواب آماده است اما بیمار دارای بدهی است
  answerStatusCode: number = 0;
  answerMessage: string = "";
  showLoadingGif: boolean = true;
  answerUrl: string = "";
  paymentUrl: string = "";
  showErrorMessage: boolean = false;
  errorMessage: string = "";

  constructor(
    private onlineAnswerService: OnlineAnswerService,
    private route: ActivatedRoute
  ) {}

  CheckAnswer() {
    this.showLoadingGif = true;
    this.answerChecked = false;
    this.showErrorMessage = false;
    this.errorMessage = "";

    this.onlineAnswerService
      .GetStatusAnswer(this.acceptionCode, this.phoneNumber)
      .subscribe(
        (data: CAnswerStatus) => {
          this.answerStatus = data;

          this.answerChecked = true;
          this.answerStatusCode = this.answerStatus.fAnswerStatus;
          this.answerUrl = "";

          switch (this.answerStatus.fAnswerStatus) {
            case 0: {
              this.answerMessage = "بیماری با این مشخصات یافت نشد";
              break;
            }
            case 1: {
              this.answerMessage = "جواب آزمایش شما آماده می باشد";
              this.answerUrl = this.onlineAnswerService.GetDownloadAnswerUrl(
                this.acceptionCode,
                this.phoneNumber
              );
              break;
            }
            case 2: {
              this.answerMessage = "جواب آزمایش شما آماده نمی باشد";
              break;
            }
            case 3: {
              this.answerMessage =
                "جواب آزمایش شما آماده می باشد. لطفا برای دریافت جواب آزمایش ابتدا تسویه حساب نمایید";
              var thisSiteUrl = document.location.origin;
              var fReturnUrlSuccess =
                thisSiteUrl +
                "/PaymentSucceeded?key=" +
                this.acceptionCode +
                "_" +
                this.phoneNumber;
              var fReturnUrlFailure = thisSiteUrl + "/PaymentFailure";
              this.paymentUrl = this.onlineAnswerService.GetAcceptionPaymentUrl(
                this.answerStatus.fCode.toString(),
                fReturnUrlSuccess,
                fReturnUrlFailure
              );
              break;
            }
          }

          this.showLoadingGif = false;
        },
        (err) => {
          this.showLoadingGif = false;
          this.errorMessage =
            "متاسفانه ارتباط با سرور برقرار نیست. لطفا مجددا سعی نمایید";
          this.showErrorMessage = true;
        }
      );
  }
}
